<style src="./ItemQuoted.scss" lang="scss" scoped></style>
<template>
  <section class="item-detail">
    <transition name="show-fade-y">
      <div class="item-detail-container" v-if="quotedItemDetails.itemQuoted">
        <div class="item-info">
          <h4>{{ quotedItemDetails.itemQuoted.lab }}</h4>
          <span class="badge-small badge-grey">{{ quotedItemDetails.quote.importedCode }}</span>
          <button type="button"
            class="button btn-small-danger"
            v-shortkey="['ctrl', 'd']"
            @shortkey="noQuote"
            @click="noQuote">
              NÃO COTAR
          </button>
        </div>

        <div class="item-description-container">
          <div class="item-identification">
            <div class="item-description">
              <h4>{{ quotedItemDetails.itemQuoted.pativo }}</h4>
              <h3>{{ quotedItemDetails.itemQuoted.comercialName }}</h3>
            </div>

            <div class="item-specs">
              <div class="panel">
                <span class="title">CUSTO</span>
                <div class="values">
                  <span
                    class="unit-value"
                    v-if="quotedItemDetails.itemQuoted.cost">
                    {{ (quotedItemDetails.itemQuoted.cost * quotedItemDetails.itemInfo.factor) | CurrencyBR(null, 4) }}
                  </span>
                  <span
                    class="total-value"
                    v-if="costTotal">
                    {{ costTotal | CurrencyBR }}
                  </span>
                </div>
              </div>

              <div class="panel" :class="{ 'no-value': !cmedComputedValue }">
                <span class="title">MAX</span>
                <div class="values">
                  <span class="unit-value">
                    {{ this.cmedComputedValue * quotedItemDetails.itemInfo.factor | CurrencyBR(null, 4) }}
                  </span>
                  <span class="total-value">
                    {{ maxTotal | CurrencyBR }}
                  </span>
                </div>
              </div>

              <div class="panel" :class="{ 'no-value': !cmedComputedValue }">
                <span class="title">L/P</span>
                <div class="values">
                  <span class="unit-value" title="Percentual de lucro">
                    {{ lpUnit | DecimalNumber(1) }}%
                  </span>
                  <span class="total-value" title="Total do lucro em reais">
                    {{ lpTotal | CurrencyBR }}
                  </span>
                </div>
              </div>
            </div>
          </div>

          <div class="item-quote-info">
            <div class="info-container">
              <span class="title">Ult. Compra</span>
              <span class="value">{{ quotedItemDetails.itemQuoted.lastBuyingDate | FriendlyDate }}</span>
            </div>

              <div class="info-container">
                <span class="title">Qt. Estoque</span>
                <span class="value">{{ quotedItemDetails.itemQuoted.stockQuantity | DecimalNumber }}</span>
            </div>

            <div class="info-container">
              <span class="title">RMS</span>
              <span class="value">{{ quotedItemDetails.itemQuoted.rmsCode }}</span>
            </div>

            <div class="info-container">
              <span class="title">GGREM</span>
              <span class="value">{{ quotedItemDetails.itemQuoted.ggremCode }}</span>
            </div>

            <div class="document-container">
              <div class="rms-anvisa" v-show="quotedItemDetails.rmsAnvisa" >
                <icon-anvisa-rms class="icon" @click.native="openAnvisaRms" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </transition>

    <transition name="show-fade-y">
      <div class="show-empty" v-if="!quotedItemDetails.itemQuoted">
        <icon-empty />
        <h2>Esse item ainda não foi cotado</h2>
      </div>
    </transition>
  </section>
</template>

<script>
import { CurrencyBR, DecimalNumber, DateBR, FriendlyDate } from '@/components/primitives/helpers/filters'
import { IconEmpty, IconAnvisaRms } from '@/components/primitives/icons'
import { mapGetters } from 'vuex'

export default {
  name: 'ItemQuoted',
  components: {
    IconEmpty,
    IconAnvisaRms
  },
  data () {
    return {}
  },
  filters: {
    CurrencyBR,
    DecimalNumber,
    DateBR,
    FriendlyDate
  },
  computed: {
    ...mapGetters({
      quotedItemDetails: 'ItemAssociation/GET_ITEM_QUOTED_DETAILS'
    }),
    cmedComputedValue () { return this.quotedItemDetails.cmedQuoted ? this.quotedItemDetails.cmedQuoted.computedValue : 0 },
    costTotal () { return this.quotedItemDetails.itemQuoted.cost * (this.quotedItemDetails.itemInfo.factor * this.quotedItemDetails.itemInfo.quantity) },
    maxTotal () { return this.quotedItemDetails.cmedQuoted ? (this.cmedComputedValue * (this.quotedItemDetails.itemInfo.factor * this.quotedItemDetails.itemInfo.quantity)) : 0 },
    lpUnit () { return ((this.maxTotal * 100) / this.costTotal) - 100 },
    lpTotal () { return this.maxTotal ? this.maxTotal - this.costTotal : 0 }
  },
  methods: {
    noQuote () {
      this.$store.dispatch('ItemAssociation/UNQUOTE_ITEM')
    },
    openAnvisaRms () {
      const serverUrl = this.$store.getters['Login/SERVER_URL']
      window.open(`${serverUrl}/document/rms/${this.quotedItemDetails.rmsAnvisa.documentFile.fileName}`)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/view/item-association/components/top-bar/item-quoted/ItemQuoted.vue